<!--分配详情--->
<template>
    <div class="page">
        <div class="temp-box">
            <div class="box_4 flex-row justify-between">
                <div class="image-wrapper_1 flex-col">
                    <img class="image_1" referrerpolicy="no-referrer" :src="customerList.empAvatar" alt="" />
                </div>
                <div class="text-wrapper_2 flex-col justify-between">
                    <span class="text_4">{{ customerList.empName }}</span>
                </div>
            </div>
        </div>
        <div class="archives-module">
            <div class="tab-box">
                <van-tabs id="tabs" line-width="25px" line-height="4px" color="#2FD0D5" title-active-color="#35434C" title-inactive-color="#A0ACB5" animated>
                    <van-tab :title="`顾客. ${customerList.contactList.length}`">
                        <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
                            <div class="main-box">
                                <div class="list" v-if="customerList.contactList.length != 0">
                                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="20" :immediate-check="false">
                                        <div style="background-color: #ffffff; padding-bottom: 1px" v-for="customerinfo in customerList.contactList" :key="customerinfo.id">
                                            <div class="section_5 flex-row">
                                                <div class="image-wrapper_1 flex-col">
                                                    <img class="image_1" referrerpolicy="no-referrer" :src="customerinfo.contactAvatar" alt="" />
                                                </div>
                                                <div class="text-wrapper_2 flex-col justify-between">
                                                    <span class="text_6">{{ customerinfo.contactName }}</span>
                                                    <span class="text_7">分配给{{ customerinfo.allottedEmpName }}</span>
                                                </div>
                                                <span class="text_8" :style="{ 'color': allotContactStatusColor.color }">{{ customerinfo.allotContactStatusDesc }}</span>
                                            </div>
                                            <div class="section_6 flex-col"></div>

                                        </div>
                                    </van-list>
                                </div>
                                <div v-else class="flex flex-col flex-y-center">
                                    <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png" class="empty-icon" alt="" />
                                    <div class="empty-txt">暂无分配详情～</div>
                                </div>
                            </div>
                        </van-pull-refresh>
                    </van-tab>
                    <van-tab title="顾客群.0">
                        <div class="flex flex-col flex-y-center">
                            <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png" class="empty-icon" alt="" />
                            <div class="empty-txt">敬请期待～</div>
                        </div>
                    </van-tab>
                </van-tabs>
            </div>
        </div>

    </div>
</template>

<script>
    import request from "@/utils/request";

    export default {
        name: "inheritDetails",
        data() {
            return {
                page: 1,
                total: 0,
                loading: false,
                finished: false,
                refreshing: false,
                id: 0,
                customerList: [],
                allotContactStatusColor: {},  //用户接替状态颜色
            };
        },
        mounted() {
            this.id = JSON.parse(this.$route.query.checkedEmployeesId);
            this.onLoad();
        },
        methods: {
            onLoad() {
                const limit = 10
                this.loading = true
                request({
                    url: `/transferCust/offAllotDetail/${this.id}`,
                    method: "get",
                })
                    .then((res) => {
                        this.customerList = res.data;
                        res.data.contactList.forEach(element => {
                            if (element.allotContactStatus == 1)
                                this.allotContactStatusColor = { 'color': 'rgba(53, 67, 76, 1)' }
                            else if (element.allotContactStatus == 2)
                                this.allotContactStatusColor = { 'color': 'blue' }
                            else if (element.allotContactStatus == 3)
                                this.allotContactStatusColor = { 'color': 'red' }
                            else if (element.allotContactStatus == 4)
                                this.allotContactStatusColor = { 'color': 'green' }
                            else if (element.allotContactStatus == 5)
                                this.allotContactStatusColor = { 'color': 'black' }
                        });

                        if (res.data.contactList.length < limit) {
                            this.finished = true
                        }
                        this.page += 1
                    }).catch(() => {
                        this.finished = true
                    }).finally(() => {
                        this.loading = false
                        this.refreshing = false
                    })
            },

            onRefresh() {
                this.page = 1
                this.finished = false;
                this.customerList = []
                this.onLoad()
            },
        },
    };
</script>
<style lang="less" scoped>
    .page {
        height: 100%;
        overflow-y: auto;
    }

    ::-webkit-scrollbar {
        display: none;
    }

    .mb-106 {
        margin-bottom: 106px;
    }

    /* ------------ */
    .archives-module {
        width: 750px;
        height: calc(100vh - 160px);
        overflow-x: hidden;
        box-shadow: inset 0px 2px 10px -11px rgba(0, 0, 0, 1);
        z-index: 1;
    }

    .main-box {
        height: 100%;
        overflow-y: auto;
        padding-top: 40px;
    }

    .tab-box {
        width: 750px;
    }

    .temp-box {
        height: 160px;
        z-index: 99;
    }

    .popup-show .van-sticky,
    .popup-show .van-sticky-wrap,
    .popup-show .tabs-index--van-tabs__line {
        z-index: unset !important;
    }

    .new_section_4 {
        background-color: rgba(245, 246, 247, 1);
        width: 750px;
    }

    .image-wrapper_1 {
        z-index: 28;
        position: relative;
        width: 70px;
        height: 70px;
        border-radius: 10px;
        overflow: hidden;
        background: url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/repeat.png) 100% no-repeat;
        margin-top: 12px;
        background-color: #fff;
    }

    .image_1 {
        z-index: 29;
        position: absolute;
        left: 0;
        top: 0;
        width: 70px;
        height: 70px;
    }

    .text_4 {
        width: 96px;
        height: 45px;
        display: inline-block;
        // color: rgba(53, 67, 76, 1);
        font-size: 32px;
        white-space: nowrap;
        // line-height: 45px;
        text-align: left;
    }

    .text_5 {
        width: 146px;
        height: 37px;
        display: inline-block;
        color: rgba(160, 172, 181, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
    }

    .section_4 {
        height: 193px;
        background-color: rgba(245, 246, 247, 1);
        width: 750px;
    }

    .box_4 {
        width: 690px;
        height: 143px;
        // margin: 30px 0 0 30px;
        position: fixed;
        z-index: 99;
        background: #fff;
    }

    .box_5 {
        height: 70px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 690px;
    }

    .block_1 {
        width: 96px;
        height: 33px;
        margin: 19px 0 0 20px;
    }

    .label_4 {
        width: 28px;
        height: 28px;
        margin-top: 2px;
        margin-left: 12px;
    }

    .text_5 {
        width: 96px;
        height: 33px;
        display: inline-block;
        color: rgba(160, 172, 181, 1);
        font-size: 24px;
        white-space: nowrap;
        line-height: 33px;
        text-align: left;
        margin: 35px 0 5px 10px;
    }

    .section_5 {
        /* margin-top: 1px; */
        height: 150px;
        /* margin: 30px 0 0 30px; */
        background-color: rgb(255 255 255);
    }

    .label_5 {
        width: 40px;
        height: 40px;
        margin-top: 60px;
        margin-left: 30px;
    }

    .image-wrapper_1 {
        z-index: 37;
        position: relative;
        width: 70px;
        height: 70px;
        border-radius: 10px;
        overflow: hidden;
        margin-left: 30px;
        margin-top: 30px;
    }

    .image_1 {
        z-index: 38;
        position: absolute;
        left: 0;
        top: 0;
        width: 70px;
        height: 70px;
    }

    .text-wrapper_2 {
        width: 90px;
        height: 92px;
        margin-left: 30px;
        margin-top: 50px;
    }

    .text_6 {
        width: 90px;
        height: 42px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 30px;
        white-space: nowrap;
        line-height: 42px;
        text-align: left;
    }

    .text_7 {
        width: 89px;
        height: 37px;
        display: inline-block;
        color: rgba(160, 172, 181, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin-top: 13px;
    }

    .text_8 {
        width: 84px;
        height: 40px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 28px;
        white-space: nowrap;
        line-height: 40px;
        text-align: left;
        margin: 60px 0 0 324px;
    }

    .label_6 {
        width: 32px;
        height: 32px;
        margin: 55px 0 0 384px;
    }

    .section_6 {
        width: 506px;
        height: 1px;
        background-color: rgba(215, 215, 215, 1);
        margin: 2px 0 0 156px;
    }

    .empty-icon {
        width: 280px;
        height: 280px;
        margin-top: 179px;
    }

    .empty-txt {
        font-size: 30px;
        color: #a0acb5;
    }

    :deep(.van-tabs--line .van-tabs__wrap) {
        position: fixed;
        width: 100%;
        z-index: 999;
    }

    :deep(.van-tabs__content--animated) {
        padding-top: 50px;
    }
</style>
